import Event from './Event';
import './Event.scss';

export default Event;
